/**
 * Ícones de 16px do "Input Chat" do Workbase DS (Figma 6087:32916): clipe de
 * anexo, seta de envio e "+" do botão "Nova conversa". Largura/altura vão no
 * `style` porque um script de terceiros injeta `svg { width: 100% }` em runtime.
 */
type ChatInputIconProps = {
  color?: string;
  size?: number;
};

export function ChatAttachIcon({
  color = "currentColor",
  size = 16,
}: ChatInputIconProps) {
  return (
    <svg
      aria-hidden
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: size, height: size, display: "block", flexShrink: 0 }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14.6667C5.05933 14.6667 2.66667 12.274 2.66667 9.33333V5.1C2.66667 3.02333 4.35667 1.33333 6.43333 1.33333C8.51 1.33333 10.2 3.02333 10.2 5.1V9.22933C10.2 10.46 9.19867 11.4613 7.96867 11.4613C6.738 11.4613 5.73667 10.46 5.73667 9.22933V5.33267C5.73667 4.964 6.03533 4.666 6.40333 4.666C6.77133 4.666 7.07 4.964 7.07 5.33267V9.22933C7.07 9.72467 7.47333 10.128 7.96867 10.128C8.464 10.128 8.86667 9.72467 8.86667 9.22933V5.1C8.86667 3.75867 7.77533 2.66667 6.43333 2.66667C5.09133 2.66667 4 3.75867 4 5.1V9.33333C4 11.5393 5.794 13.3333 8 13.3333C10.206 13.3333 12 11.5393 12 9.33333V3.254C12 2.88533 12.2987 2.58733 12.6667 2.58733C13.0347 2.58733 13.3333 2.88533 13.3333 3.254V9.33333C13.3333 12.274 10.9407 14.6667 8 14.6667Z"
        fill={color}
      />
    </svg>
  );
}

export function ChatSendIcon({
  color = "currentColor",
  size = 16,
}: ChatInputIconProps) {
  return (
    <svg
      aria-hidden
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: size, height: size, display: "block", flexShrink: 0 }}
    >
      <path
        d="M7.81688 2.16667C7.8777 2.16667 7.93668 2.1755 7.99266 2.19076C7.99911 2.19251 8.00581 2.19336 8.01219 2.19531C8.10743 2.22439 8.19294 2.27518 8.2648 2.34049C8.27292 2.34788 8.28175 2.35482 8.28954 2.36263L12.3065 6.39583C12.5661 6.65668 12.5652 7.07941 12.3045 7.33919C12.0437 7.59896 11.621 7.598 11.3612 7.33724L8.48355 4.44661V12.8333C8.48355 13.2015 8.18507 13.5 7.81688 13.5C7.44881 13.4999 7.15022 13.2014 7.15022 12.8333V4.44792L4.27326 7.33724C4.0135 7.59779 3.59137 7.59873 3.33055 7.33919C3.06964 7.0794 3.06881 6.65674 3.3286 6.39583L7.34488 2.36263C7.40045 2.30689 7.46501 2.26247 7.53498 2.22982C7.54331 2.22592 7.55121 2.22101 7.55972 2.21745C7.59474 2.20284 7.63132 2.19206 7.66844 2.18359C7.67367 2.1824 7.6788 2.18075 7.68407 2.17969C7.69332 2.17781 7.70272 2.17662 7.71206 2.17513C7.74622 2.16972 7.78121 2.16668 7.81688 2.16667Z"
        fill={color}
      />
    </svg>
  );
}

export function ChatPlusIcon({
  color = "currentColor",
  size = 16,
}: ChatInputIconProps) {
  return (
    <svg
      aria-hidden
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: size, height: size, display: "block", flexShrink: 0 }}
    >
      <path
        d="M8 3.33334C8.36819 3.33334 8.66667 3.63181 8.66667 4V7.33334H12C12.3682 7.33334 12.6667 7.63181 12.6667 8C12.6667 8.36819 12.3682 8.66667 12 8.66667H8.66667V12C8.66667 12.3682 8.36819 12.6667 8 12.6667C7.63181 12.6667 7.33334 12.3682 7.33334 12V8.66667H4C3.63181 8.66667 3.33334 8.36819 3.33334 8C3.33334 7.63181 3.63181 7.33334 4 7.33334H7.33334V4C7.33334 3.63181 7.63181 3.33334 8 3.33334Z"
        fill={color}
      />
    </svg>
  );
}
